import { Provider } from '@angular/core';
import { CX_ABSTRACT_COMPONENT, CX_ABSTRACT_SECTION } from '@b2b/components/cms/cx-abstract/cx-abstract.tokens';
import { CxAbstractComponentProvider, CxAbstractSectionProvider } from '@b2b/components/cms/cx-abstract/cx-abstract.types';

export function provideComponent(value: CxAbstractComponentProvider): Provider {
  return {
    provide: CX_ABSTRACT_COMPONENT,
    useValue: value,
    multi: true,
  };
}

export function provideSection(value: CxAbstractSectionProvider): Provider {
  return {
    provide: CX_ABSTRACT_SECTION,
    useValue: value,
    multi: true,
  };
}
